<template>
    <div>
        <b-modal :title="'Asignar timbres a ' + Nombre" class="modal-success" cancel-title="Cerrar" ok-title="Asignar"  v-model="open" @ok.prevent="asingarTimbres" @hidden="clear">
            <b-form-group id="timbres" description="Cantidad de timbres a asignar" label="Timbres"
            :feedback="errors.Timbres | fetchErrors"
            :state="TimbresHasErrors"
            >
              <b-form-input type="text" v-mask="'#########'" id="timbres" :state="TimbresHasErrors" min="1" v-model.trim="draft.Timbres"></b-form-input>
            </b-form-group>

            <b-form-group id="factura" description="Número de factura de compra" label="Factura"
            :feedback="errors.Factura | fetchErrors"
            :state="FacturaHasErrors"
            >
              <b-form-input type="text"  id="factura" :state="FacturaHasErrors" v-model.trim="draft.Factura"></b-form-input>
            </b-form-group>
            <div slot="modal-footer" class="w-100">
                <div class="float-right">
                    <b-btn variant="secondary" @click="open=false">
                        Cerrar
                    </b-btn>
                    <template v-if="loading === false">
                        <b-btn :disable="loading" variant="primary" @click="asingarTimbres">
                            Actualizar
                        </b-btn>
                    </template>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import EventBus from '@/event-bus.js'

export default
{
  name: 'Asignar',
  data () {
    return {
      Nombre: '',
      loading: false,
      draft: {
        Timbres: 1,
        Factura: 1,
        Id: 0
      },
      open: false,
      errors: {}
    }
  },
  methods: {
    asingarTimbres () {
      this.loading = true
      var response = this.$store.dispatch('asignarTimbres', this.draft)
      response.then(response => {
        EventBus.$emit('Asignacion', true)
        this.fetchDistribuidores()
        this.fetchDistribuidor()
        this.clear()
      }).catch(errors => {
        this.open = true
        this.loading = false
        this.errors = errors.response.data
      })
    },
    clear () {
      this.open = false
      this.draft = {Timbres: 1, Factura: 1, Id: 0}
      this.loading = false
      this.errors = {}
    },
    fetchDistribuidores () {
      let response = this.$store.dispatch('fetchDistribuidores')
      response.then(response => {
        this.$store.commit('distribuidores', response.data)
      }).catch(errors => {
        this.$store.commit('authLogout', '')
        this.$router.push('/login')
      })
    },
    fetchDistribuidor () {
      let response = this.$store.dispatch('fetchDistribuidor', this.draft.Id)
      response.then(response => {
        this.distribuidor = response.data
      }).catch(errors => {
        this.$store.commit('authLogout', '')
        this.$router.push('/login')
      })
    }
  },
  filters: {
    fetchErrors (errors) {
      return (typeof errors === 'undefined') ? '' : (errors.length > 0) ? errors[0] : ''
    }
  },
  mounted () {
    EventBus.$on('abrirModalAsignar', distribuidor => {
      this.open = true
      this.draft.Id = distribuidor.Id
      this.Nombre = distribuidor.Nombre
    })
  },
  computed: {
    TimbresHasErrors () {
      let message = (typeof this.errors.Timbres === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    FacturaHasErrors () {
      let message = (typeof this.errors.Factura === 'undefined') ? 'valid' : 'invalid'
      return message
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Distribuidores/Crud/Asignar.vue